const type = "DASHBOARD/";

export const dashboardConstants = {
  LISTING_REQUEST: `${type}LISTING_REQUEST`,
  LISTING_SUCCESS: `${type}LISTING_SUCCESS`,
  LISTING_FAILURE: `${type}LISTING_FAILURE`,
};
